import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="PrivacyPolicy">
      <h1>Privacy Policy</h1>

      <p>Last updated: 11/11/2024</p>

      <h2>1. Introduction</h2>
      <p>Welcome to Elephant Discovery! We value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.</p>

      <h2>2. Information We Collect</h2>
      <h3>2.1 Personal Data</h3>
      <p>We may collect personal data such as your name, email address, phone number, and any other information you provide when contacting us or making a booking.</p>
      
      <h3>2.2 Usage Data</h3>
      <p>We collect data on how you interact with our website, such as IP address, browser type, pages visited, and time spent on pages, to improve your experience on our platform.</p>
      
      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To provide and improve our services, including booking confirmations and customer support.</li>
        <li>To personalize your experience on our website and send notifications or promotional content (with your consent).</li>
        <li>To improve website functionality and monitor website performance.</li>
      </ul>

      <h2>4. Sharing Your Information</h2>
      <p>We do not sell or rent your personal data. We may share your information only in the following situations:</p>
      <ul>
        <li>With third-party service providers who help us operate our business and website, including payment processing and email services.</li>
        <li>If required by law, or to respond to legal requests and prevent harm to our users.</li>
      </ul>

      <h2>5. Security of Your Information</h2>
      <p>We implement appropriate security measures to protect your personal data from unauthorized access, use, or disclosure. However, please be aware that no security system is impenetrable.</p>

      <h2>6. Your Data Protection Rights</h2>
      <p>You have the right to access, update, or delete your personal data. You may also withdraw consent or object to certain uses of your data. If you would like to exercise these rights, please contact us at elephantdiscovery@gmail.com</p>

      <h2>7. Cookies</h2>
      <p>We use cookies to enhance your browsing experience. Cookies are small files stored on your device that help us remember your preferences and improve our website’s functionality. You can manage cookie settings in your browser.</p>

      <h2>8. Links to Other Websites</h2>
      <p>Our website may contain links to other websites. We are not responsible for the content or privacy practices of these external sites. We encourage you to read their privacy policies.</p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>We may update our Privacy Policy from time to time. Changes will be posted on this page, and we encourage you to review this page periodically for any updates.</p>

      <h2>10. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at:</p>
      <p>Email: elephantdiscovery@gmail.com</p>
      <p>Phone: +66 64 336 6553</p>
      <p>TAT License : 23/03616</p>
    </div>
  );
};

export default PrivacyPolicy;
